import React from 'react';
import { Wrapper } from './style';
import Input from 'shared/search/input/index';

export default ({ onClick }) => (
  <Wrapper>
    <Input header onClick={onClick} />
  </Wrapper>
);
